// eslint-disable-next-line no-shadow
export var EAxiosMethod;
(function (EAxiosMethod) {
    EAxiosMethod["GET"] = "GET";
    EAxiosMethod["POST"] = "POST";
    EAxiosMethod["PUT"] = "PUT";
    EAxiosMethod["DELETE"] = "DELETE";
})(EAxiosMethod || (EAxiosMethod = {}));
